// Shared Socket.io client for the MEETING module (presence + WebRTC signaling).
//
// One connection per logged-in tab, authenticated with the same JWT the REST
// API uses (sent in the handshake `auth.token`). Connect AFTER login only —
// never on the login page (no token yet).
//
// URL resolution:
//   - VUE_APP_SOCKET_URL wins if set.
//   - dev (npm run serve): same origin → the devServer proxies /api/socket.io
//     to the local API (see vue.config.js), so we connect to window.location.origin.
//   - prod: same origin (nginx proxies /api/ → the API on :3000).

import { io } from 'socket.io-client'

const SOCKET_URL = process.env.VUE_APP_SOCKET_URL
  || (typeof window !== 'undefined' ? window.location.origin : '/')

let socket = null

export function getSocket () {
  return socket
}

export function connectSocket () {
  const token = localStorage.getItem('accessToken')
  if (!token) return null

  if (socket) {
    if (!socket.connected) socket.connect()
    return socket
  }

  socket = io(SOCKET_URL, {
    // Must match the server path (api/server.js). Riding /api/ means the
    // existing nginx proxy (WS-enabled) carries the socket — no nginx change.
    path: '/api/socket.io/',
    // Read the token at EVERY connection attempt: it rotates daily, and a
    // reconnect with the token captured at page load used to be refused
    // ("Unauthorized") for ever — presence gone, calls impossible.
    auth: (cb) => cb({ token: localStorage.getItem('accessToken') }),
    autoConnect: true,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 4000,
    timeout: 10000
  })

  return socket
}

export function disconnectSocket () {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}

export default { getSocket, connectSocket, disconnectSocket }
